import { ModuleContext } from "@/stores/moduleConst";
import store from "@/stores/store";
import CookieKey from "@/commons/wildcards/constants/CookieKey";
import commonFunction from "@/commons/commonFunction";

import { useSyncTabData } from '@/setup/utilities/syncTabData.js';
import { showError } from '@/commons/globalMessage';
export const useContextStorage = () => {

  /**
   * Set context vào local storage để làm source context gốc
   * @param {*} context 
   */
  const setSourceContextStorage = (context, isCompatible) => {
    //#region compatible with old version
    if (isCompatible) {
      try {
        //Nếu context mới có sử dụng mutil tabs thì sẽ set luôn vào session storage
        if (context && context.Context && context.Context.UseMutilTabs) {
          localStorage.setItem(window._key_context || 'session_context', JSON.stringify({context}));
          sessionStorage.setItem(window._key_context || 'session_context', JSON.stringify({context}));
        }
      } catch (error) {
        console.log(error);
      }
    }
    //#endregion
  }

  /**
   * Set context của tab hiện tại vào cookie
   */
  const setCookieContext = () => {
    const context = store.state[ModuleContext];
    if (context.Context) {
      const { Context } = context;
      const daySeconds = 86400;
      commonFunction.setCookie(CookieKey.DatabaseId, Context.DatabaseId, daySeconds);
      commonFunction.setCookie(CookieKey.BudgetCode, Context.BudgetCode, daySeconds);
    }
  }

  /**
   * remove context khi inactive tab
   */
  const removeCookieContext = () => {
    commonFunction.removeCookie(CookieKey.DatabaseId);
    commonFunction.removeCookie(CookieKey.BudgetCode);
  }

  /**
   * Parse posted do bị serialize về string
   * @param {*} context 
   */
  const parsePostedDate = (context) => {
    try {
      context.TokenExpired = new Date(context.TokenExpired);

      if (context.PostedDate) {
        context.PostedDate = new Date(context.PostedDate);
      } else {
        let now = new Date();
        context.PostedDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      }
    } catch (ex) {
      console.error(ex);
    }
  }

  /**
   * Parse context từ session storage
   * @param {*} key 
   * @returns 
   */
  const parseContext = (key) => {
    let contextInSession = sessionStorage.getItem(key);
    if (!contextInSession) {
      const contextInLocalStorage = localStorage.getItem(key);
      if (contextInLocalStorage) {
        contextInSession = contextInLocalStorage;
        sessionStorage.setItem(key, contextInSession);
      } else {
        return null;
      }
    }
    if (typeof contextInSession === 'string') {
      const contextObject = JSON.parse(contextInSession);
      const context = contextObject.context;
      if (context && context.Token) {
        context.Context = context.Context || {};
        parsePostedDate(context);
      }
      return contextObject;
    }
    return null;
  }

  /**
   * Set lại context vào session storage
   * @param {*} key 
   * @param {*} context 
   */
  const setContext = (key, context) => {
    sessionStorage.setItem(key, JSON.stringify(context));
  }

  /**
   * Subcrible session change
   */
  const subcribleSyncSessionChange = () => {
    const keySync = window.sync_key_session || '_subcrible_session_change';
    useSyncTabData(keySync, (newSessionId) => {
      const context = store.state[ModuleContext];
      if (context && context.Context) {
        const { Context } = context;
        const sessionId = Context.SessionId;
        if (sessionId !== newSessionId) {
          showError('Phần mềm sẽ tự động tải lại trang để đảm bảo toàn vẹn dữ liệu.', 'Bạn đã đăng xuất').then(() => {
            location.reload();
          });
        }
      }

    });
  }

  const onSessionChange = (sessionId) => {
    const notificationKey = window.sync_key_session || '_subcrible_session_change';
    if (!sessionId) {
      onLogoutSession();
    } else {
      localStorage.setItem(notificationKey, sessionId);
    }
  }

  const clearSession = () => {
    sessionStorage.removeItem(window._key_context || 'session_context');
  }

  const onLogoutSession = () => {
    const notificationKey = window.sync_key_session || '_subcrible_session_change';
    localStorage.removeItem(notificationKey);
    clearSession();
  }

  return { setSourceContextStorage, setCookieContext, parseContext, setContext, clearSession, removeCookieContext, subcribleSyncSessionChange, onSessionChange };
}